import { getMessages, getNotifications } from 'containers/Chats/chatSlice'
import { getObjectsState } from 'containers/Warehouses/warehousesSlice'
import { selectIsLoggedIn } from 'containers/Login/loginSlice'
import React, { useEffect, useRef, useState } from 'react'
import { useReduxDispatch, useReduxSelector } from 'store'
import ConnectionContext from './Context'

interface ConnectionProviderProps {
  children: React.ReactNode
}

const ConnectionProvider: React.FC<ConnectionProviderProps> = ({ children }) => {
  const isLoggedIn = useReduxSelector(selectIsLoggedIn)
  const [isOnline, setOnline] = useState(Date.now())
  const dispatch = useReduxDispatch()

  const currentIsLoggedIn = useRef(isLoggedIn)
  currentIsLoggedIn.current = isLoggedIn

  useEffect(() => {
    const handleOnline = () => {
      setOnline(Date.now())
      if (currentIsLoggedIn.current || window.location.pathname.startsWith('/shared')) {
        dispatch(getObjectsState(true))
      }
      dispatch(getNotifications())
      dispatch(getMessages())
    }

    const handleOffline = () => {
      setOnline(0)
    }

    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        handleOnline()
      } else {
        handleOffline()
      }
    }

    window.addEventListener('online', handleOnline)
    window.addEventListener('offline', handleOffline)
    document.addEventListener('visibilitychange', handleVisibilityChange)

    return () => {
      window.removeEventListener('online', handleOnline)
      window.removeEventListener('offline', handleOffline)
      document.removeEventListener('visibilitychange', handleVisibilityChange)
    }
  }, [dispatch])

  return (
    <ConnectionContext.Provider value={isOnline}>
      {children}
    </ConnectionContext.Provider>
  )
}

export default ConnectionProvider